/* eslint-disable no-script-url */
import { Link, useLocation } from "react-router-dom";
import { FooterWrapper } from "../styles/StyledComponents/FooterWrapper";
import assests from "../ui/assests";
import FacebookIcon from "../ui/icons/FacebookIcon";
import InstagramIcon from "../ui/icons/InstagramIcon";
import LocationIcon from "../ui/icons/LocationIcon";
import MailIcon from "../ui/icons/MailIcon";
import PhoneIcon from "../ui/icons/PhoneIcon";
import TwitterIcon from "../ui/icons/TwitterIcon";
import YoutubeIcon from "../ui/icons/YoutubeIcon";

const Footer = () => {
  const navMenu = [
    {
      list: "Home",
      route: "/",
    },
    {
      list: " About",
      route: "/about",
    },
    {
      list: "Service",
      route: "/service",
    },
    {
      list: "Career",
      route: "/career",
    },
    {
      list: "Solutions",
      route: "/solutions",
    },
    {
      list: "Projects",
      route: "#url",
    },
  ];

  const location = useLocation();
  const pathname = location.pathname;

  return (
    <FooterWrapper>
      <img
        src={assests.FooterLineImage}
        alt="FooterLineImage"
        className="footerLine_bg_Image"
      />
      <div className="ftr_upper_wrap">
        <div className="container">
          <div className="ftr_upper">
            <div className="row footer_row">
              <div className="footer_col footerLeftBox">
                <Link to={"/"} className="footer_logo">
                  <img src={assests.logo} alt="footer_logo" />
                </Link>
                <p className="description_text">
                  EMIIT is a full-service web design and digital solutions
                  agency, specializing in custom websites, app development,
                  UI/UX design, SEO, and digital marketing. We help businesses
                  of all sizes elevate their online presence with innovative,
                  user-centric, and results-driven strategies.
                </p>
                <div className="social_link_div">
                  <p className="ftr_cmn_heading">Follow Us</p>
                  <ul className="social_Media_Icons">
                    <li>
                      <Link to={"#url"}>
                        <FacebookIcon />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#url"}>
                        <InstagramIcon />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#url"}>
                        <YoutubeIcon />
                      </Link>
                    </li>
                    <li>
                      <Link to={"#url"}>
                        <TwitterIcon />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="footer_col">
                <p className="ftr_cmn_heading">Quick Links</p>
                <ul className="footer_nav_links">
                  {navMenu?.map((data, index) => (
                    <li
                      key={index}
                      className={pathname === data.route ? "active" : ""}
                    >
                      <Link to={data?.route}>{data?.list}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer_col ftr_Contact_col">
                <p className="ftr_cmn_heading">Contact Information</p>
                <ul className="ftr_contact_list">
                  <li>
                    <i aria-hidden="true">
                      <LocationIcon IconWidth="25px" IconHeight="25px" />
                    </i>
                    <span>Amarabati, Sodepur, Kolkata-700110</span>
                  </li>
                  <li>
                    <Link to="tel:+917003652673">
                      <i aria-hidden="true">
                        <PhoneIcon IconWidth="25px" IconHeight="25px" />
                      </i>
                      <span>+91 7003652673</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="mailto:emiitkolkata2024@gmail.com">
                      <i aria-hidden="true">
                        <MailIcon IconWidth="25px" IconHeight="25px" />
                      </i>
                      <span>emiitkolkata2024@gmail.com</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ftr_btm">
        <div className="container">
          <p className="description_text">
            © copyright reserved 2025
            <Link to={"/"}>EMiiT</Link>
          </p>
        </div>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
